import {Component, Output, OnInit, EventEmitter, Input, ViewChild, ElementRef, OnDestroy} from '@angular/core';
import {KeyboardService} from '../../services';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'cpui-logo-nav',
  templateUrl: './logo-nav.component.html',
  styleUrls: ['./logo-nav.component.scss']
})
export class LogoNavComponent implements OnInit, OnDestroy {
  private keyupSubscription: Subscription;
  defaultNavState = 'welcome';
  activeNavState: string;
  antennaWiggleState = false;
  @Input() isLoading = false;
  @Input() blurLogoNav = false;
  @Input() blurLogoNavMobile = false;

  @ViewChild('logoNav_componentButton') componentButton: ElementRef;
  @ViewChild('logoNav_productButton') productButton: ElementRef;
  @ViewChild('logoNav_userButton') userButton: ElementRef;
  @ViewChild('logoNav_interfaceButton') interfaceButton: ElementRef;

  @Input('navState')
  set navState(navState: string) {
    this.setActiveNavState(navState);
  }

  @Output() logoNavStateChange: EventEmitter<string> = new EventEmitter();

  constructor(private keyboardService: KeyboardService) {
  }

  ngOnInit() {
    console.log(`CPUI - LogoNavComponent.ngOnInit()`);
    this.keyupSubscription = this.keyboardService.onDocumentKeyupObservable().subscribe((event) => this.onDocumentKeyup(event));
  }

  ngOnDestroy() {
    if (this.keyupSubscription) {
      this.keyupSubscription.unsubscribe();
    }
  }

  isNavStateActive(navStateTriggered, navStateToTest): boolean {
    return (navStateTriggered === navStateToTest && this.activeNavState === navStateToTest);
  }

  handleEscape(event): void {
    let escapeNavState = this.defaultNavState;
    if (this.activeNavState === 'component') {
      escapeNavState = 'C';
    }
    if (this.activeNavState === 'product') {
      escapeNavState = 'P';
    }
    if (this.activeNavState === 'user') {
      escapeNavState = 'U';
    }
    if (this.activeNavState === 'interface') {
      escapeNavState = 'I';
    }

    if (escapeNavState !== this.activeNavState) {
      this.logoNavigate(event, escapeNavState);
    }
  }

  handleArrowRight(event, navStateTriggered): void {
    if (this.isNavStateActive(navStateTriggered, 'C')) {
      this.logoNavigate(event, 'P');
    }
    if (this.isNavStateActive(navStateTriggered, 'P')) {
      this.logoNavigate(event, 'product');
    }
    if (this.isNavStateActive(navStateTriggered, 'U')) {
      this.logoNavigate(event, 'I');
    }
    if (this.isNavStateActive(navStateTriggered, 'I')) {
      this.logoNavigate(event, 'interface');
    }
  }

  handleArrowLeft(event, navStateTriggered): void {
    if (this.isNavStateActive(navStateTriggered, 'C')) {
      this.logoNavigate(event, 'component');
    }
    if (this.isNavStateActive(navStateTriggered, 'P')) {
      this.logoNavigate(event, 'C');
    }
    if (this.isNavStateActive(navStateTriggered, 'U')) {
      this.logoNavigate(event, 'user');
    }
    if (this.isNavStateActive(navStateTriggered, 'I')) {
      this.logoNavigate(event, 'U');
    }
  }

  handleArrowUp(event, navStateTriggered): void {
    if (this.isNavStateActive(navStateTriggered, 'U')) {
      this.logoNavigate(event, 'C');
    }
    if (this.isNavStateActive(navStateTriggered, 'I')) {
      this.logoNavigate(event, 'P');
    }
  }

  handleArrowDown(event, navStateTriggered): void {
    if (this.isNavStateActive(navStateTriggered, 'C')) {
      this.logoNavigate(event, 'U');
    }
    if (this.isNavStateActive(navStateTriggered, 'P')) {
      this.logoNavigate(event, 'I');
    }
  }

  onDocumentKeyup(keyupEvent: KeyboardEvent): void {
    const isEscape = (keyupEvent.key === 'Escape' || keyupEvent.key === 'Esc');

    if (isEscape) {
      console.log(`CPUI - LogoNavComponent.onDocumentKeyup() ESCAPE`, keyupEvent, this.activeNavState);

      this.handleEscape(keyupEvent);
    }
  }

  logoNavigate(event, navState: string): void {
    console.log(`CPUI - LogoNavComponent.logoNavigate()`, {event, navState, activeNavState: this.activeNavState});
    const activeNavState = (this.activeNavState === navState) ? this.defaultNavState : navState;

    this.setActiveNavState(activeNavState);
    this.logoNavStateChange.emit(activeNavState);
  }

  logoNavKey(event: KeyboardEvent, navStateTriggered): void {
    if (event) {
      event.preventDefault();
    }
    console.log(`CPUI - LogoNavComponent.logoNavKey()`, {
      event,
      navStateTriggered,
      activeNavState: this.activeNavState
    });
    const {key} = event;

    if (key === 'ArrowRight') {
      this.handleArrowRight(event, navStateTriggered);
    }

    if (key === 'ArrowLeft') {
      this.handleArrowLeft(event, navStateTriggered);
    }

    if (key === 'ArrowUp') {
      this.handleArrowUp(event, navStateTriggered);
    }

    if (key === 'ArrowDown') {
      this.handleArrowDown(event, navStateTriggered);
    }
  }

  setActiveNavState(navState): void {
    console.log(`CPUI - LogoNavComponent.setActiveNavState()`, navState);
    this.activeNavState = navState;

    if (this.activeNavState === 'C' || this.activeNavState === 'component') {
      this.componentButton.nativeElement.focus();
    } else if (this.activeNavState === 'P' || this.activeNavState === 'product') {
      this.productButton.nativeElement.focus();
    } else if (this.activeNavState === 'U' || this.activeNavState === 'user') {
      this.userButton.nativeElement.focus();
    } else if (this.activeNavState === 'I' || this.activeNavState === 'interface') {
      this.interfaceButton.nativeElement.focus();
    } else {
      this.componentButton.nativeElement.focus();
    }
  }

  wiggleAntenna(): void {
    this.antennaWiggleState = !this.antennaWiggleState;

    setTimeout(() => {
      this.antennaWiggleState = false;
    }, 1005);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/logo-nav/logo-nav.component.ts